<template>
  <div>
    <el-button icon="el-icon-plus" type="primary" size="small" @click="addItem"
      >添加预警条件</el-button
    >
    <el-table :data="list" size="small" class="mt-10">
      <el-table-column
        prop="model_number"
        align="left"
        :label="title"
      ></el-table-column>
      <el-table-column align="left" label="预警条件（最近一次维修后）">
        <template slot-scope="scope">
          寿命值达到<span class="text-danger">{{
            scope.row.warning_current_day
          }}</span
          >天
          <span class="text-danger ml-5 mr-5">{{
            scope.row.warning_condition_type == 2 ? '且' : '或'
          }}</span>
          工作时长达到<span class="text-danger">{{
            scope.row.warning_current_hour
          }}</span
          >小时
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-popconfirm
            title="确认删除该预警条件吗？"
            @confirm="hanldeDelte(scope.row, scope.$index)"
          >
            <el-link
              slot="reference"
              type="danger"
              class="font-12 ml-5"
              :underline="false"
              >删除</el-link
            >
          </el-popconfirm>
          <el-link
            type="primary"
            class="font-12 ml-5"
            :underline="false"
            @click="editItem(scope.row, scope.$index)"
            >编辑</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <MyFormer
      :labelTitle="title"
      :model="model"
      :show.sync="formerVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></MyFormer>
  </div>
</template>

<script>
import {
  templateWarningRuleList,
  templateWarningRuleDelete,
} from '@/service/getData'
import MyFormer from './former'

export default {
  components: {
    MyFormer,
  },
  props: {
    title: {
      type: String,
      default: '型号',
    },
    productTemplateId: {
      type: Number,
      default: 0,
    },
    itemTemplateId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      model: {
        model_number: '',
        product_template_id: 0,
        item_template_id: 0,
        warning_current_day: 0,
        warning_condition_type: 1,
        warning_current_hour: 0,
      },
      formerVisible: false,
      editIndex: -1,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let res = await templateWarningRuleList({
        product_template_id: this.productTemplateId,
        item_template_id: this.itemTemplateId,
      })

      if (res.status == 0) {
        this.list = res.data
      }
    },
    addItem() {
      this.model = {
        model_number: '',
        product_template_id: this.productTemplateId,
        item_template_id: this.itemTemplateId,
        warning_current_day: 0,
        warning_condition_type: 1,
        warning_current_hour: 0,
      }
      this.formerVisible = true
    },

    editItem(item, index) {
      this.formerVisible = true
      this.$nextTick(() => {
        this.editIndex = index
        this.model = this.clone(item)
      })
    },

    createdCallback(data) {
      this.list.push(data)
    },

    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
    },

    async hanldeDelte(item, index) {
      let res = await templateWarningRuleDelete(item.id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
  },
}
</script>